// ── Singleton Location Service ────────────────────────────────────────────────
// Guarantees exactly ONE location resolution per page load regardless of how
// many components call getIPLocation() simultaneously.
//
// Uses a backend proxy at /api/geo-location (IP-based, city-level accuracy).
// CSP-safe — the browser only talks to 'self'; the server tries multiple
// providers (ipapi.co → ipinfo.io → geojs.io) with 10-minute caching.
// No browser permission prompt — completely silent.
// ─────────────────────────────────────────────────────────────────────────────
let _promise = null;

/**
 * Returns { city, region, region_code, country, lat, lng, label, fullAddress }
 * or null if the service fails.
 */
export function getIPLocation() {
  if (!_promise) {
    _promise = _fetchLocation();
  }
  return _promise;
}

async function _fetchLocation() {
  try {
    const res = await fetch("/api/geo-location");
    if (!res.ok) return null;
    const data = await res.json();
    if (data.city && data.lat && data.lng) return data;
  } catch { /* service unavailable */ }
  return null;
}

/** Call on logout / hard reset to force a fresh lookup on the next request. */
export function clearIPLocationCache() {
  _promise = null;
}
